var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFooterFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-footer-facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.68,
    height: 30.68,
    viewBox: "0 0 30.68 30.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook_1_",
    "data-name": "facebook (1)",
    d: "M30.68,15.34A15.34,15.34,0,1,0,15.34,30.68c.09,0,.18,0,.27-.006V18.738h-3.3V14.9h3.3V12.068c0-3.278,2-5.063,4.926-5.063a26.772,26.772,0,0,1,2.954.15v3.428H21.476c-1.588,0-1.9.755-1.9,1.864v2.445h3.805l-.5,3.841H19.576V30.087A15.345,15.345,0,0,0,30.68,15.34Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFooterFacebook);
export default __webpack_public_path__ + "static/media/ico-footer-facebook.f61b32481599fab7eb1a54c3a59eff6e.svg";
export { ForwardRef as ReactComponent };